/**
 * Students feature hooks
 */

export * from "./useStudentCreate";
export * from "./useStudentDelete";
export * from "./useStudentBulkDelete";
export * from "./useStudentGet";
export * from "./useStudentRegister";
export * from "./useStudentsGet";
export * from "./useStudentUpdate";
export * from "./useStudentTaskSubmit";

